var _path, _path2, _path3, _rect, _rect2, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomV2HealthAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24838 2.49689V4.99793",
    stroke: "#7A7670",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7516 2.49689V4.99793",
    stroke: "#7A7670",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99995 17.5032H4.99787C3.61658 17.5032 2.49683 16.3834 2.49683 15.0021V6.24848C2.49683 4.86719 3.61658 3.74744 4.99787 3.74744H15.002C16.3833 3.74744 17.5031 4.86719 17.5031 6.24848V10",
    stroke: "#7A7670",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 13,
    width: 2,
    height: 2,
    rx: 0.5,
    fill: "#7A7670"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 7,
    width: 2,
    height: 2,
    rx: 0.5,
    fill: "#7A7670"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11L7.5 9.5M7.5 9.5L6 8M7.5 9.5L9 8M7.5 9.5L6 11",
    stroke: "#7A7670",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16L14.5 14.5M14.5 14.5L13 13M14.5 14.5L16 13M14.5 14.5L13 16",
    stroke: "#7A7670",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomV2HealthAlert);
export default __webpack_public_path__ + "static/media/customV2HealthAlert.d91232e6e2c3bd5f1fa51b400c54e081.svg";
export { ForwardRef as ReactComponent };